var render = function render(){var _vm=this,_c=_vm._self._c;return _c('extra-table',{attrs:{"title":_vm.$t('products'),"entity":"products","fields":_vm.fields,"search":""},scopedSlots:_vm._u([{key:"header",fn:function({ selected }){return undefined}},{key:"editForm",fn:function(props){return [_c('extra-product',{attrs:{"product":props.item,"errors":props.errors}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }